import React, { useRef } from "react";
import eyeShow from "../../../Assets/Icons/eyeShow.svg";
import eyeHide from "../../../Assets/Icons/eyeHide.svg";

const TextInput = ({
  Icon,
  type,
  name,
  value,
  placeholder,
  inputClass,
  iconAreaClass,
  handleChange,
  handleBlur,
  error,
  touched,
  inputDivClass,
  innerDivClass,
  showPassword,
  togglePassword,
  autoComplete,
  onClick,
  maxLength
}) => {
  // Note: Avoid key filtering to prevent IME/virtual keyboard issues on mobile

  const inputRef = useRef(null);

  return (
    <div className={`w-full flex flex-col ${inputDivClass ? inputDivClass : ""}`}>
      <div
        className={
          innerDivClass
            ? `relative flex ${innerDivClass}`
            : "relative flex h-[35px] sm:h-[45px] md:h-[50px]"
        }
      >
        {Icon && (
          <div className={`flex justify-center items-center ${iconAreaClass ? iconAreaClass : ""}`}>
            <img
              src={Icon}
              alt=""
              className="w-5 h-5 sm:w-7 sm:h-7 object-contain"
            />
          </div>
        )}

        <input
          ref={inputRef}
          type={type ? type : name === 'email' ? 'email' : 'text'}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={onClick}
          placeholder={placeholder}
          autoComplete={autoComplete ? autoComplete : "off"}
          maxLength={maxLength}
          className={`flex-1 w-full outline-none text-[12px] md:text-[14px] font-[400] font-poppins ${inputClass}`}
        />

        {(name === "password" || name === "confirmPassword") && (
          <div className="absolute right-[2%] top-0 h-full flex flex-col justify-center">
            {showPassword ? (
              <img
                src={eyeShow}
                className="cursor-pointer w-[25px]"
                onClick={togglePassword}
                alt="eye show"
              />
            ) : (
              <img
                src={eyeHide}
                className="cursor-pointer w-[25px]"
                onClick={togglePassword}
                alt="eye hide"
              />
            )}
          </div>
        )}
      </div>

      <div className="min-h-[10px] sm:min-h-[10px] md:min-h-[12px]">
        {error && touched ? (
          <span className="text-red-600 text-[11px] sm:text-[12px] md:text-[13px] font-[600] font-poppins ms-1 mt-0">
            {error}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default TextInput;